// Múi giờ hiển thị của web = múi của WORKSPACE đang mở (`active_tenant.company_timezone`, máy chủ trả ở đăng nhập /
// làm mới token / đổi workspace / `/auth/me` — authService.loadWorkspaceTimezone).
//
// Vì sao (12/10/2026): kernel cnv-ui ghim giờ VN làm mặc định cho mọi giờ in ra + «hôm nay» — người Toronto thấy tin
// nhắn 13:00Z in «08:00 p.m.», và từ ~13h EDT việc hạn hôm nay đã hiện «quá hạn». Kernel nay có
// `setDisplayTimezone` (mặc định vẫn giờ VN cho Work/Core); host này khai múi workspace — chính múi máy chủ Connect
// dùng để cắt ngày (tenantClockService), nên «hôm nay» hai đầu khớp.
//
// Áp ĐỒNG BỘ trước lần vẽ đầu: `activeTenant` nằm trong localStorage (zustand persist) nên đọc được ngay lúc khởi động.
import { setDisplayTimezone, getDisplayTimezone } from '@cnv/ui/i18n';
import { useAuthStore } from './authStore';

/** Múi giờ của workspace trong một `activeTenant` — thiếu ⇒ null (kernel tự về giờ VN). */
export function tzCuaWorkspace(activeTenant) {
  const tz = activeTenant?.company_timezone;
  return typeof tz === 'string' && tz ? tz : null;
}

// Đếm số lần phải DỰNG LẠI cây trang vì múi đổi giữa chừng (xem DisplayTimezoneGate trong main.jsx).
let lanDung = 0;
const nguoiNghe = new Set();

export function subscribeDungLai(fn) {
  nguoiNghe.add(fn);
  return () => nguoiNghe.delete(fn);
}
export function getLanDung() {
  return lanDung;
}

/**
 * Xử lý một lần đổi `activeTenant`. Tách khỏi `noiMuiGioWorkspace` để test được không cần store.
 *
 * Dựng lại cây CHỈ khi múi đổi mà vẫn CÙNG một workspace đang mở (lần đầu sau khi lên bản — phiên lưu từ trước chưa
 * có `company_timezone`, `/auth/me` mới mang về; hoặc admin đổi múi ở nơi khác). Trang đang mở đã in giờ theo múi cũ,
 * nhiều chỗ tính nhãn trong `useMemo` không theo dõi múi ⇒ vẽ lại không đủ, phải dựng lại.
 * KHÔNG dựng lại lúc đăng nhập (trước đó chưa có workspace — trang đăng nhập không in giờ nào, dựng lại giữa lúc
 * `await login()` là tháo chính trang đang điều hướng) và lúc đổi sang workspace KHÁC (trang chọn workspace tự điều
 * hướng; thanh trên cùng thì tải lại cả trang).
 */
export function apDoiWorkspace(sau, truoc) {
  const muiTruoc = getDisplayTimezone();
  const muiSau = setDisplayTimezone(tzCuaWorkspace(sau));
  const cungWorkspace = !!truoc?.tenant_id && truoc.tenant_id === sau?.tenant_id;
  if (muiSau !== muiTruoc && cungWorkspace) {
    lanDung += 1;
    for (const fn of nguoiNghe) {
      try { fn(); } catch { /* một người nghe hỏng không chặn người khác */ }
    }
  }
  return muiSau;
}

let daNoi = false;
/** Gọi MỘT lần ở main.jsx, TRƯỚC `render`. */
export function noiMuiGioWorkspace() {
  if (daNoi) return;
  daNoi = true;
  setDisplayTimezone(tzCuaWorkspace(useAuthStore.getState().activeTenant));
  useAuthStore.subscribe((state, prev) => {
    if (state.activeTenant === prev.activeTenant) return;
    apDoiWorkspace(state.activeTenant, prev.activeTenant);
  });
}
